export const BaseOption = ({ value, children }) => {
  return <option value={value}>{children}</option>;
};

export default BaseOption;